module.exports = __webpack_public_path__ + "media/application/images/customers/hawkhouse-f28fd6616d1b8dbd1f1112308a41f0ac.jpg";